import type { CloudflareResizeOptions } from './CloudflareResizeOptions';
import type { SrcSetAnchor } from './types';

/**
 * Width requested when a caller asks for a CDN URL without stating a size.
 * Any width keeps the request on the CDN — without one the origin serves the
 * full-size upload, unresized and uncompressed.
 */
export const FALLBACK_IMAGE_WIDTH = 640;

export const defaultSrcSetParams: Record<
  SrcSetAnchor,
  CloudflareResizeOptions
> = {
  '320w': { fit: 'contain', width: 320 },
  '480w': { fit: 'contain', width: 480 },
  '640w': { fit: 'contain', width: 640 },
  '800w': { fit: 'contain', width: 800 },
  '1280w': { fit: 'contain', width: 1280 },
};
